import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";

const SET_LOADING = 'SET_LOADING';
const SET_ORIGINAL_TEXT = 'SET_ORIGINAL_TEXT';
const SET_CONTENT = 'SET_CONTENT';
const SET_PARAMS = 'SET_PARAMS';
const SET_API = 'SET_API';
const SET_KIND = 'SET_KIND';

const MESSAGES = {
    expired: 'Tu contrato ha expirado o ha excedido el número máximo de documentos.',
    trial: '',
    renovation: ''

}

const state = () => ({
    loading: false,
    original_text: '',
    content: '',
    kind: '',
    api: '',
    params: {}
});


const mutations = {
    SET_LOADING: (state, loading) => {
        state.loading = loading;
    },
    SET_ORIGINAL_TEXT: (state, text) => {
        state.original_text = text;
    },
    SET_CONTENT: (state, content) => {
        state.content = content;
    },
    SET_PARAMS: (state, params) => {
        state.params = params;
    },
    SET_API: (state, api) => {
        state.api = api;
    },
    SET_KIND: (state, kind) => {
        state.kind = kind;
    },
    updateField,
};


const getters = {
    loading: state => state.loading,
    content: state => state.content,
    getField
}


const init = ({ commit, dispatch, state }, { params, kind, api }) => {
    commit(SET_LOADING, true);
    commit(SET_PARAMS, params);
    commit(SET_API, api);
    commit(SET_KIND, kind);
    let promise = new Promise((resolve, reject) => {
        client.get(state.api + '/' + state.kind).then((response) => {
            let content = response.data.content;
            commit(SET_ORIGINAL_TEXT, content);
            dispatch('updateContent');
            commit(SET_LOADING, false);
            resolve(response);
        }, (error) => {
            commit(SET_LOADING, false);
            reject()
        });
    });
    return promise
}

const updateContent = ({ commit, dispatch, state }) => {
    let content = state.original_text;
    if (content) {
        Object.entries(state.params).forEach(element => {
            if (element[1]) {
                content = content.replaceAll("{{ " + element[0] + " }}", element[1]);
                content = content.replaceAll("{{" + element[0] + "}}", element[1]);
            } else {
                content = content.replaceAll("{{ " + element[0] + " }}", "");
                content = content.replaceAll("{{" + element[0] + "}}", "");
            }
        });
        commit(SET_CONTENT, content);
    }
}

const setParams = ({ commit }, params) => {
    commit(SET_PARAMS, params);    
}
const updateParams = ({ commit, state, dispatch}, params) => {
    let newParams = Object.assign(state.params, params);
    commit(SET_PARAMS, newParams);
    dispatch('updateContent')
}


const actions = {
    init,
    updateContent,
    setParams,
    updateParams
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}